import { createTheme, Theme } from '@mui/material/styles';

declare module '@mui/material/styles/createPalette' {
  interface Palette {
    blue: ColorPartial;
    disabled: PaletteColorOptions;
    errorSecondary: Palette['primary'];
  }

  interface PaletteOptions {
    blue?: ColorPartial;
    nav?: PaletteColorOptions;
    disabled?: PaletteColorOptions;
    errorSecondary?: PaletteOptions['primary'];
  }
}

export const DefaultTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#089af7',
      dark: '#007bd8',
      light: 'rgba(8,154,247,0.16)'
    },
    secondary: {
      main: 'rgba(0,125,255,0.08)',
      contrastText: '#089af7',
      dark: 'rgba(0,125,255,0.16)'
    },
    error: {
      main: '#E25650',
      dark: '#C33731',
      light: 'rgba(226, 86, 80, 0.12)'
    },
    errorSecondary: {
      main: 'rgba(226, 86, 80, 0.16)',
      dark: 'rgba(226, 86, 80, 0.3)',
      light: 'rgba(226, 86, 80, 0.05)',
      contrastText: '#E25650'
    },
    background: {
      default: '#f9fafb'
    },
    text: {
      primary: '#1C3D64',
      secondary: '#5E6C84'
    },
    divider: '#E9EAEE',
    action: {
      active: '#8993A4'
    },
    blue: {
      50: 'rgba(112, 203, 248, 0.16)',
      500: '#089AF7'
    },
    disabled: {
      light: '#05374A',
      main: '#05374A'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1920
    }
  },
  typography: {
    subtitle2: {
      color: '#1C3D64'
    },
    body2: {
      color: '#565F6F'
    }
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
          ':hover': {
            textDecoration: 'underline'
          }
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: 'white'
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          border: '2px solid #E9EAEE',
          borderRadius: '6px'
        },
        rounded: {
          ':first-of-type': {
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px'
          },
          ':last-of-type': {
            borderBottomLeftRadius: '6px',
            borderBottomRightRadius: '6px'
          }
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          color: '#1C3D64',
          backgroundColor: '#F0F1F4',
          padding: '0 22px',
          '&$expanded': {
            minHeight: 'inherit'
          }
        },
        content: {
          margin: 0,
          '&$expanded': {
            margin: 0
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: 'none',
          backgroundColor: 'white'
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: 'rgba(0, 125, 255, 0.08)'
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '40px 48px 0 48px'
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          paddingTop: 4,
          paddingLeft: 48,
          paddingRight: 48
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          paddingLeft: 48,
          paddingRight: 48,
          paddingBottom: 40
        }
      }
    }
  }
});
